<template>
    <div>
        <app-bar :title="t('external_contents_title')"></app-bar>

        <v-layout>
            <external-content-collection></external-content-collection>
        </v-layout>
    </div>
</template>

<script lang="ts">
    import { defineComponent, reactive, toRefs } from '@vue/composition-api'
    import { useI18n } from 'vue-i18n-composable'
    import ExternalContentCollection from '@/components/external-contents/ExternalContentCollection.vue'

    export default defineComponent({
        components: {
            ExternalContentCollection,
        },

        /**
         * @param props
         */
        setup(props) {
            const state = reactive({})

            return {
                ...useI18n(),
                ...toRefs(state)
            }
        }
    })
</script>
